export default __webpack_public_path__ + "static/media/acropass-ac-care-plus-temporary.c7668445.png";